import { useTranslation } from "react-i18next";

function renderLines(value) {
  return String(value || "")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}

function renderPeriod(periodStart, periodEnd) {
  return [periodStart, periodEnd].filter(Boolean).join(" ~ ");
}

export default function ProjectReportUd1000PdfCoverOverviewPage({
  contractName,
  periodStart,
  periodEnd,
  contractor,
  participantText,
  participantCount,
  participantNames,
  purpose,
  analysisResultText,
  diagnosisResult,
  analysisOpinionLines = [],
}) {
  const { t } = useTranslation();
  const purposeLines = renderLines(purpose);
  const participantLines = renderLines(
    participantText || [participantCount, participantNames].filter(Boolean).join("\n"),
  );
  const diagnosisLines = renderLines(analysisResultText || diagnosisResult);
  const opinionLines = Array.isArray(analysisOpinionLines)
    ? analysisResultText
      ? []
      : analysisOpinionLines.filter(Boolean)
    : renderLines(analysisOpinionLines);
  const periodLabel = renderPeriod(periodStart, periodEnd);

  return (
    <div
      className="projectReportUd1000CoverPage is-overview"
      data-report-cover="true"
    >
      <div className="projectReportUd1000CoverShell">
        <div className="projectReportUd1000OverviewRow">
          <div className="projectReportUd1000OverviewLabel">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.contractName", {
              defaultValue: "1. \uC6A9\uC5ED\uBA85\uCE6D : ",
            })}
          </div>
          <div className="projectReportUd1000OverviewValue">{contractName}</div>
        </div>
        <div className="projectReportUd1000OverviewRow">
          <div className="projectReportUd1000OverviewLabel">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.period", {
              defaultValue: "2. \uC6A9\uC5ED\uC77C\uC790 : ",
            })}
          </div>
          <div className="projectReportUd1000OverviewValue">{periodLabel}</div>
        </div>
        <div className="projectReportUd1000OverviewRow">
          <div className="projectReportUd1000OverviewLabel">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.contractor", {
              defaultValue: "3. \uC6A9\uC5ED\uC5C5\uCCB4 : ",
            })}
          </div>
          <div className="projectReportUd1000OverviewValue">{contractor}</div>
        </div>
        <div className="projectReportUd1000OverviewRow">
          <div className="projectReportUd1000OverviewLabel">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.participants", {
              defaultValue: "4. \uCC38\uC5EC\uC778\uC6D0 : ",
            })}
          </div>
          <div className="projectReportUd1000OverviewValue">
            {participantLines.map((line, index) => (
              <div
                className={index === 0 ? undefined : "projectReportUd1000OverviewSubValue"}
                key={`participant-${index}`}
              >
                {line}
              </div>
            ))}
          </div>
        </div>
        <div className="projectReportUd1000OverviewSection">
          <div className="projectReportUd1000OverviewSectionTitle">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.purpose", {
              defaultValue: "5. \uC9C4\uB2E8\uBAA9\uC801",
            })}
          </div>
          <div className="projectReportUd1000OverviewParagraph purpose">
            {purposeLines.map((line, index) => (
              <p key={`purpose-${index}`}>{line}</p>
            ))}
          </div>
        </div>

        <div className="projectReportUd1000OverviewSection">
          <div className="projectReportUd1000OverviewSectionTitle">
            {t("projectDetail.projectReportEditor.ud1000Cover.overview.analysis", {
              defaultValue: "6. \uC9C4\uB2E8\uACB0\uACFC \uBD84\uC11D\uC758\uACAC",
            })}
          </div>
          <div className="projectReportUd1000OverviewParagraph diagnosis">
            {diagnosisLines.map((line, index) => (
              <p key={`result-${index}`}>{line}</p>
            ))}
            {opinionLines.map((line, index) => (
              <p key={`opinion-${index}`}>{line}</p>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
